import { ServiceConfig } from '@user/store/services/config'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { APIError, get, post, put, remove } from '@user/store/services/crud'
import {
  CustomizedResultsSetting,
  SearchListItem,
} from '@user/store/search/typings'

export interface Prop {
  entityType: string
  entityId: number
}

const baseUrl = `${ServiceConfig.baseAPIUrl}/Search`

export const getRecentSearches = createAsyncThunk<SearchListItem[]>(
  'recentlyVisited',
  async (_model, thunkApi) => {
    const response = await get(`${baseUrl}/RecentlyVisited`)
    if (response.ok) return await response.json()
    return thunkApi.rejectWithValue(await response.json())
  },
)

export const saveRecentSearch = createAsyncThunk<true, Prop>(
  'recentlyVisited/save',
  async (searchItem, thunkApi) => {
    const response = await post(`${baseUrl}/RecentlyVisited`, searchItem)

    if (response.ok) return await response.json()
    return thunkApi.rejectWithValue(await response.json())
  },
)

export const deleteAllRecentSearches = createAsyncThunk<boolean>(
  'recentlyVisited/delete',
  async (_searchItem, thunkApi) => {
    const response = await remove(`${baseUrl}/RecentlyVisited`)

    if (response.ok) return true
    return thunkApi.rejectWithValue(await response.json())
  },
)

export const getCustomizedResultsSettings = createAsyncThunk<
  CustomizedResultsSetting[]
>('CustomizedResultsSettings', async (_model, thunkApi) => {
  const response = await get(`${baseUrl}/CustomizeResultsSettings`)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const saveCustomizedResultsSettings = createAsyncThunk<
  boolean,
  CustomizedResultsSetting[],
  { rejectValue: APIError }
>(
  'CustomizedResultsSettings/save',
  async (customizedResultsSettings, thunkApi) => {
    const response = await put(
      `${baseUrl}/CustomizeResultsSettings`,
      customizedResultsSettings,
    )
    if (response.ok) {
      return response.ok
    }
    return thunkApi.rejectWithValue(await response.json())
  },
)
